import { marketSpecialsToggleFilter } from "@faire/retailer-visitor-shared/features/FaireMarkets/consts";
import { suppliersPath } from "@faire/retailer-visitor-shared/paths/suppliers/suppliersPath";
import { useRetailerRoutingContext } from "@faire/retailer-visitor-shared/RetailerRoutingContextProvider";
import { useSettingReplaceMarketHubWithBrandsPage } from "@faire/retailer-visitor-shared/settings/useSettingReplaceMarketHubWithBrandsPage";
import marketsAllSpecials from "@faire/web-api--source/routes/www/markets/event_type/all-specials";
import { useMemo } from "react";

import { useMarketCurrentEvent } from "./useMarketCurrentEvent";

export const useSuppliersBrandLinkWithMarketsFilter = () => {
  const { currentEventType } = useMarketCurrentEvent();
  const routingContext = useRetailerRoutingContext();
  const replaceMarketHubWithBrandsPage =
    useSettingReplaceMarketHubWithBrandsPage();

  const marketsPath = useMemo(
    () => marketsAllSpecials(currentEventType),
    [currentEventType]
  );

  const suppliersBrandPath = useMemo(
    () =>
      suppliersPath({
        urlIds: [{ id: "All Brands" }],
        queryParams: {
          filters: marketSpecialsToggleFilter,
        },
        routingContext,
      }),
    [routingContext]
  );

  return replaceMarketHubWithBrandsPage ? suppliersBrandPath : marketsPath;
};
